import { render } from "./AboutPthPeje.vue?vue&type=template&id=a96e3fa8&scoped=true"
import script from "./AboutPthPeje.vue?vue&type=script&lang=js"
export * from "./AboutPthPeje.vue?vue&type=script&lang=js"

import "./AboutPthPeje.vue?vue&type=style&index=0&id=a96e3fa8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a96e3fa8"]])

export default __exports__